import Vuex from "vuex";
import http from "./http";
import chart from './store/modules/chart.js';
import series from './store/modules/series.js';

Vue.use(Vuex);

export default new Vuex.Store({

    modules: {
        chart: chart,
        series: series,
    },

    state: {
        id: null,
        count: 0,
        data: {},
        rawData: {},
        loading: false,

        chartTypesMotion: [
            {description: "Column Chart", type: 'column', img: 'column.svg'},
            {description: "Bar Chart", type: 'bar', img: 'bar.svg'},
            {description: "Pie Chart", type: 'pie', img: 'pie.svg'},
            {description: "Scatter Plot", type: 'scatter', img: 'scatter_plot.svg'},
            {description: "Variwide", type: 'variwide', img: 'variwide.svg'},
            //{description: "Bubble Chart", type: 'bubble', img: 'pie.svg'},
        ],

        chartFlip: [
            {description: "X -> Y", swap: false},
            {description: "Y -> X", swap: true},
        ],

        periodicityItems: [
            {description: 'Annual', p: 'A'},
            {description: 'Quarterly', p: 'Q'},
            {description: 'Monthly', p: 'M'},
            {description: 'Daily', p: 'D'},
        ],

        dimensions: {
            x: {key: 'Indicator', value: ''},
            y: {key: 'Indicator', value: ''},
            z: {key: 'Indicator', value: ''},
            group: 'Reporting Country',
        },

        time: '2018-01', // dummy time

        aggregates: [],

        stacking: null,

        type: 'line',
        typeMotion: 'column',
        tableSwap: false,

        periodicity: null,

        colors: [],
        backgroundColor: '#fff',

        error: null,
    },
    // actions can be asynchronous!
    actions: {
        update({commit, state}, parameters) {
            state.loading = true;
            http
                .post("/panels/" + state.id, {
                    _method: 'patch',
                    action: parameters.action,
                    periodicity: state.periodicity,
                    ids: parameters.ids,
                    parameter: parameters.parameters,
                    colors: state.colors,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },
        getData({commit, state}, id) {
            if (id === null) {
                return;
            }
            state.id = id;
            state.loading = true;
            http.get("/panels/" + id)
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },
        updateChart({state}, parameters) {
            // TODO sync with server!
            state.type = parameters.type;
            state.stacking = parameters.stacking;
        },
        updateChartMotion({state}, parameters) {
            // TODO sync with server!
            state.typeMotion = parameters.type;
        },
        updateTable({state}, parameters) {
            // TODO sync with server!
            state.tableSwap = parameters.swap;
        },
        updateVisibility({state, commit}, parameters) {
            state.rawData.visibility = parameters.visibility;

            state.loading = true;
            http
                .post("/panels/" + state.id, {
                    _method: 'patch',
                    visibility: parameters.visibility,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {

                    state.error = error;
                });
        },
        addSeries({commit, state, dispatch}, parameters) {
            if (state.id === null) {
                return dispatch('create', {
                    list: [parameters.id],
                });
            }

            state.loading = true;
            http
                .post("/panels/" + state.id, {
                    _method: 'patch',
                    add_series: true,
                    id: parameters.id,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },
        setSeries({commit, state, dispatch}, parameters) {
            if (state.id === null) {
                return dispatch('create', parameters);
            }

            state.loading = true;
            http
                .post("/panels/" + state.id, {
                    _method: 'patch',
                    set_series: true,
                    list: parameters.list,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },
        create({commit, state}, parameters) {
            state.loading = true;
            http
                .post('/panels', {
                    series: parameters.list,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },
        deleteSeries({commit, state}, index) {
            state.loading = true;
            http
                .post("/panels/" + state.id, {
                    _method: 'patch',
                    delete_series: index,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },
        setHeadline({commit, state}, parameters) {
            state.loading = true;
            http
                .post("/panels/" + state.id, {
                    _method: 'patch',
                    headline: parameters.headline,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },
        setColors({commit, state}, parameters) {
            state.colors = parameters.colors;
            //state.backgroundColor = parameters.backgroundColor;
            //state.textColor = parameters.textColor;

            if (!parameters.store) {
                return;
            }

            http
                .post("/panels/" + state.id, {
                    _method: 'patch',
                    colors: parameters.colors,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        }
    },
    // like global computed properties
    getters: {
        getVisible:
            (state, getters) => {
                if (!getters.hasData) {
                    return [];
                }

                return state.rawData.data[state.periodicity].aggregates
                    .concat(state.rawData.data[state.periodicity].data)
                    .map(function (item, key) {
                        item.color = state.colors[key % 10];
                        return item;
                    })
                    .filter(function (item) {
                        return item.visible;
                    });
            },
        hasData: state => {
            if (!state.rawData.data || !state.rawData.data[state.periodicity]) {
                return false;
            }
            return true;
        },
        min:
            (state, getters) => {
                if (!getters.hasData) {
                    return null;
                }

                let min = null;
                state.rawData.data[state.periodicity].data.forEach(function (series) {
                    series.data.forEach(function (item) {
                        if (item.value === null) {
                            return;
                        }
                        if (min === null) {
                            min = item.value;
                        }
                        if (item.value < min) {
                            min = item.value;
                        }
                    })
                });

                return min;
            },
        max:
            (state, getters) => {
                if (!getters.hasData) {
                    return null;
                }

                let max = null;
                state.rawData.data[state.periodicity].data.forEach(function (series) {
                    series.data.forEach(function (item) {
                        if (item.value === null) {
                            return;
                        }
                        if (max === null) {
                            max = item.value;
                        }
                        if (item.value > max) {
                            max = item.value;
                        }
                    })
                });

                return max;
            },
        periodicities: state => {
            if (!state.rawData.data) {
                return [];
            }

            return state.periodicityItems.filter(function (item) {
                return state.rawData.data[item.p] !== undefined;
            });
        },
        futureDates:
            state => {
                if (!state.rawData.data) {
                    return [];
                }

                return state.rawData.data[state.periodicity].future_dates;
            },
        sources:
            state => {
                if (!state.rawData.data) {
                    return '';
                }

                return state.rawData.source;
            },
        indicators:
            state => {
                if (!state.rawData.indicators) {
                    return '';
                }

                return state.rawData.indicators;
            },
        dimensions: state => {
            if (!state.rawData.data) {
                return [];
            }

            const dim = state.rawData.data[state.periodicity].data.map(function (series) {
                return series.dimensions;
            });

            return _.chain(dim)
                .filter(function (item) {
                    return item !== null;
                })
                .flatten()
                .groupBy(function (item) {
                    return Object.keys(item)[0];
                })
                .map(function (items, key) {
                    let values = _.chain(items)
                        .map(function (foo) {
                            return Object.values(foo)[0];
                        })
                        .uniq()
                        .value();
                    return {
                        key: key,
                        values: values,
                    };
                })
                .value();
        },
        dimensionIntermediate: state => {
            if (!state.rawData.data) {
                return [];
            }

            // only run if dimensions are defined
            if (!state.rawData.data[state.periodicity].data[0].dimensions) {
                return [];
            }

            return _.chain(state.rawData.data[state.periodicity].data)
                .groupBy(function (series) {

                    let foo = series.dimensions.find(function (x) {
                        return Object.keys(x)[0] === state.dimensions.group;
                    });
                    return foo[state.dimensions.group];
                })
                .map(function (group, key) {
                    // one member of this group is x.
                    const x = group.find(function (item) {
                        return item.dimensions.find(function (foo) {
                            return Object.keys(foo)[0] === state.dimensions.x.key;
                        })[state.dimensions.x.key] === state.dimensions.x.value;
                    });

                    const y = group.find(function (item) {
                        return item.dimensions.find(function (foo) {
                            return Object.keys(foo)[0] === state.dimensions.y.key;
                        })[state.dimensions.y.key] === state.dimensions.y.value;
                    });

                    if (!x || !y) {
                        return {};
                    }

                    let xx = {};
                    x.data.forEach(function (item) {
                        xx[item.time] = item.value;
                    });

                    let yy = {};
                    y.data.forEach(function (item) {
                        yy[item.time] = item.value;
                    });

                    return {
                        x: xx,
                        y: yy,
                        name: key,
                    }
                })
                .value()
        },
        dimensionData: (state, getters) => {
            return getters.dimensionIntermediate.map(function (item, key) {
                if (!item.x || !item.y) {
                    return {
                        x: null,
                        y: null,
                        z: null,
                        name: item.name,
                        color: state.colors[key % 10],
                    };
                }

                // we can optimize this by precomputing...
                return {
                    x: item.x[state.time] ? item.x[state.time] : null,
                    y: item.y[state.time] ? item.y[state.time] : null,
                    z: 10,
                    name: item.name,
                    color: state.colors[key % 10],
                };
            });
        },
        variwideData: (state, getters) => {
            return getters.dimensionIntermediate.map(function (item) {
                if (!item.x || !item.y) {
                    return {};
                }

                // we can optimize this by precomputing...
                return [
                    item.name, item.x[state.time] ? item.x[state.time] : null, item.y[state.time] ? item.y[state.time] : null,
                ];
            });
        },
        history: (state) => {
            if (!state.rawData.data || !state.rawData.data[state.periodicity]) {
                return [];
            }

            return state.rawData.data[state.periodicity].data;
        },
        series: (state) => {
            if (!state.rawData.data || !state.rawData.data[state.periodicity]) {
                return [];
            }

            return state.rawData.data[state.periodicity].data;
        },
        allSeries: (state) => {
            if (!state.rawData.data || !state.rawData.data[state.periodicity]) {
                return [];
            }

            return _.chain(state.rawData.data)
                .map(function (item) {
                    return item.data;
                })
                .flatten()
                .value();
        },
        isEmpty: (state, getters) => {
            return getters.series === undefined || getters.series.length === 0;
        },
    },

    mutations: {// mutations must be synchronous!
        storeRaw(state, response) {
            let payload = response.data
            state.rawData = payload;
            state.loading = false;

            // are we new?
            if (state.id !== payload.id && payload.id !== undefined) {
                document.location = '/en/dashboards/' + payload.id;
                state.id = payload.id;
                return; // do not update...
            }

            let periodicities = state.periodicityItems.filter(function (item) {
                return state.rawData.data[item.p] !== undefined;
            });

            if (!state.periodicity || !periodicities.includes(state.periodicity)) {
                if (periodicities.length > 0) {
                    state.periodicity = periodicities[0].p;
                }
            }

            state.colors = payload.colors;
        },
        setPeriodicity: function (state, payload) {
            state.periodicity = payload;
        },
        setDimension: function (state, payload) {
            state.dimensions[payload.dimension] = payload;
        },
        setGroup: function (state, payload) {
            state.dimensions.group = payload;
        },
        setTime: function (state, payload) {
            state.time = payload;
        },
    }
});
